import React, { FC } from 'react';
import { ReactComponent as Representatives } from '../../../assets/Reprsentatives/representatives.svg';

export const RepresentativesUserIcon: FC = () => <Representatives />;
